import { ScopedKubeconfigsDatatable } from './components/ScopedKubeconfigsDatatable';
import { useAllScopedKubeconfigs } from './queries/useAllScopedKubeconfigs';
import { useEnvironmentNames } from './queries/useEnvironmentNames';

/**
 * The account page's own section, beside Access Tokens: every scoped kubeconfig
 * you hold, across all environments, so they are not hunted environment by
 * environment. Section rather than a page, so it carries no PageHeader.
 *
 * An administrator is served everyone's rows by this endpoint, so the Owner
 * column is shown when there is more than one owner to distinguish.
 */
export function AccountScopedKubeconfigsDatatable() {
  const scopedKubeconfigsQuery = useAllScopedKubeconfigs();
  const environmentNames = useEnvironmentNames();
  const scopedKubeconfigs = scopedKubeconfigsQuery.data ?? [];

  const owners = new Set(scopedKubeconfigs.map((k) => k.username));

  return (
    <ScopedKubeconfigsDatatable
      dataset={scopedKubeconfigs}
      isLoading={scopedKubeconfigsQuery.isLoading}
      tableKey="account-scoped-kubeconfigs"
      showOwner={owners.size > 1}
      showEnvironment
      environmentNames={environmentNames}
      description="Read-only kubeconfigs issued to you for Kubernetes environments. Revoking one stops any kubectl session using it immediately."
    />
  );
}
